import { BlobProvider, DocumentProps } from '@react-pdf/renderer'
import { ReactElement, useEffect, useRef } from 'react'

interface iDisparoProps {
  blob: Blob | null
  error: Error | null
  nomeArquivo: string
  onConcluir: () => void
  onErro: (erro: Error | null) => void
}

const Disparo: React.FC<iDisparoProps> = ({ blob, error, nomeArquivo, onConcluir, onErro }) => {
  const jaDisparou = useRef(false)

  useEffect(() => {
    if (jaDisparou.current) {
      return
    }

    if (error !== null) {
      jaDisparou.current = true
      onErro(error)
      return
    }

    if (blob === null) {
      return
    }

    jaDisparou.current = true

    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = nomeArquivo
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    setTimeout(() => URL.revokeObjectURL(url), 30000)

    onConcluir()
  }, [blob, error])

  return null
}

interface iProps {
  documento: ReactElement<DocumentProps>
  nomeArquivo: string
  onConcluir: () => void
  onErro: (erro: Error | null) => void
}

export const BaixarRelatorio: React.FC<iProps> = ({ documento, nomeArquivo, onConcluir, onErro }) => {
  return (
    <BlobProvider document={documento}>
      {({ blob, error }) => (
        <Disparo
          blob={blob}
          error={error}
          nomeArquivo={nomeArquivo}
          onConcluir={onConcluir}
          onErro={onErro}
        />
      )}
    </BlobProvider>
  )
}
